import { grid } from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '18 - 1x2',
  imageCount: 18,
  displayGroup: 'DG_EXCHANGE',
  calc: (height) => grid(3, 6, height)
};
